export default {
  methods: {
    isFileSupported(file) {
      return this.allowedFile.some(s => {
        return file.name.toLowerCase().endsWith(s)
      })
    },
  },
}
